<template>
  <v-container fluid class="pa-0">

    <Titulo></Titulo>



    <!-- <br v-if="screen < 800"> -->


    <v-stepper v-model="e1" elevation="0" :class="Vstep">
        <div :class="Vflex">
          <NavBar v-if="loadMounted == true" :step="3" :typePlan="userData.typePlan"></NavBar>
          <v-stepper-header>
            <div class="circle-step">
              <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
              </v-stepper-step>
            </div>
            <v-divider></v-divider>
            <div class="circle-step">
              <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Plan
              </v-stepper-step>
            </div>
            <v-divider></v-divider>
            <div class="circle-step">
              <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
              </v-stepper-step>
            </div>
            <v-divider></v-divider>
            <div class="circle-step2">
              <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 12" step="5">Datos
              </v-stepper-step>
            </div>

          </v-stepper-header>
        </div>
      <v-stepper-items>
        <br><br>
        <div v-if="screen < 800" style="margin-top: -12%; margin-bottom: 6%;">
            <img :src="doctorImageMobile" alt="Image doctor"  style="display: flex;justify-content: center; border-radius: 8px; width: 86%;margin: auto;">
        </div>
        <h3 v-if="userData.typePlan == 'Individual' || userData.typePlan == 'Familiar'" :class="labelTitulo">
                    {{ capitalizeName(userData.name) }} ayúdanos a conocer tu estado de salud.  
        </h3>

        <h3 v-else class="text-center labelSuperior">
            {{ capitalizeName(userData.name) }}  ayúdanos a conocer tu estado de salud. 
        </h3>
        <br>
        <p :class="labelRecommend" style="">Te recomendamos responder con información verídica para no afectar tu cobertura.</p>
        <br>

        <v-row :class="rowBody">
          <div v-if="screen > 800" style="margin: auto; max-width: 200px; width: 25%; display: inherit; margin-top: 3%;" >
            <img :src="doctorImage" alt="Image doctor"  style="border-radius: 8px; margin-left: -14%; ">
          </div>
          
          <v-stepper-content step="6"  style=" max-width: 75%; gap: 2%;">
          <v-form ref="form2" v-model="valid">
            <v-container style="justify-content: center; display: flex; flex-direction: column; align-items: center;">
              <div class="form-container">
                <div :class="vista">

                  
                  <br v-if="screen > 800"><br>

                  <h3 :class="labelTitulo" style="justify-content: left; display: flex;width: 100% !important;">
                    Declaración Personal de Salud
                  </h3>

                  <br>
                  <br>
        
                  <label :class="labelTexto">
                    ¿Te encuentras actualmente en estudio de un posible cáncer y/o tienes un diagnóstico oncológico o has recibido uno o más tratamientos oncológicos en los últimos 5 años?
                  </label>
                  <br><br>
                  <div v-if="this.planData.plan.cantBenf.includes('familiar')">
                    <v-radio-group v-model="userData.questionOne" :rules="questionRules" required row>
                      <div :class="vRadioSelect">
                        <v-row>
                          <label :class="nameRadio">{{ userData.name }}</label>
                        
                          <v-radio label="Sí" value="Si">
                          </v-radio>
                          <v-radio label="No" value="No">
                          </v-radio>
                          <hr class="hrline" style="width: 100%;">
                        </v-row><br>
                      </div>
                    </v-radio-group>
                    <div v-for="(benef, index) in benefData" :key="index">
                      <v-radio-group v-model="benef.questionOne" :rules="questionRules" required row>
                        <div :class="vRadioSelect">
                         <v-row>
                            <label :class="nameRadio">{{ benef.name }}</label>
                          
                            <v-radio label="Sí" value="Si">
                            </v-radio>
                            <v-radio label="No" value="No">
                            </v-radio>
                            <hr class="hrline" style="width: 100%;">
                          </v-row><br>
                        </div>
                      </v-radio-group>
                    </div>
                  </div>
                  

                  <div v-else>
                    <v-radio-group v-model="userData.questionOne" :rules="questionRules" required row>
                      <div :class="vRadioSelect">
                        <v-radio label="Sí" value="Si">
                        </v-radio>
                        <v-radio label="No" value="No">
                        </v-radio>
                      </div>
                    </v-radio-group>
                  </div>

                  <br v-if="screen > 800"><br>

                </div>

              </div>

              <p></p>
              <p></p>
              

              <div class="form-container" style="margin-top: -3%;">
                <div :class="vista">


                  <label :class="labelBeneficioss">
                    ¿Te encuentras actualmente en estudio o conocimiento y/o has sido diagnosticado y/o sometido a tratamiento médico por alguna de las siguientes causas?

                    <br>
                    <br>

                    • Virus Hepatitis B o Hepatitis C <br>
                    • Virus VIH <br>

                  </label>
                  <br>
                  <div v-if="this.planData.plan.cantBenf.includes('familiar')">
                    <v-radio-group v-model="userData.questionTwo" required :rules="questionRules" row>
                      <div :class="vRadioSelect">
                        <v-row>
                          <label :class="nameRadio">{{ userData.name }}</label>
                          <v-radio label="Sí" value="Si">
                          </v-radio>
                          <v-radio label="No" value="No">
                          </v-radio>
                          <hr class="hrline" style="width: 100%;">
                        </v-row><br>
                        
                      </div>
                    </v-radio-group>
                    <div v-for="(benef, index) in benefData" :key="index">
                      <v-radio-group v-model="benef.questionTwo" required :rules="questionRules" row>
                        <div :class="vRadioSelect">
                          <v-row>
                            <label :class="nameRadio">{{ benef.name }}</label>
                            
                            <v-radio label="Sí" value="Si">
                            </v-radio>
                            <v-radio label="No" value="No">
                            </v-radio>
                            <hr class="hrline" style="width: 100%;">
                          </v-row><br>
                          
                        </div>
                      </v-radio-group>
                    </div>
                  </div>

                  <div v-else>
                    <v-radio-group v-model="userData.questionTwo" required :rules="questionRules" row>
                      <div :class="vRadioSelect">
                        <v-radio label="Sí" value="Si">
                        </v-radio>
                        <v-radio label="No" value="No">
                        </v-radio>
                      </div>
                    </v-radio-group>
                  </div>
                  <br v-if="screen < 800">
                </div>
                </div>
                <br v-if="screen > 800">
              <div :class="textLegal">
                <p :class="textLegalDetalle"><b style="color: #2A3881;">Aviso:</b> De acuerdo al art. 8 bis de la Ley Nacional del Cáncer N°21.258, no debe declarar enfermedades oncológicas si han transcurridos 5 años o más desde la finalización del tratamiento radical de cáncer sin recaída posterior.</p>
              </div>

              <br>
              <br>
              <p></p>
              <p></p>

              <br v-if="screen < 800">
              <br v-if="screen < 800">
              <br v-if="screen < 800">
              
            <div :class="buttonContainer"> 
              <div class="button-container">
                <div :class="summaryContainerDps">
                  <div v-if="screen < 800" style="display: flex;color: white;padding-top: 2%; padding-bottom: 10%;">
                    <div style="display: flex;height: 31px;width: 100%;">
                      <img :src="shieldIconMobile" alt="shieldIcon" class="iconMobile">
                      <div style="display: block;">
                        <p class="iconTitle">Tipo de plan:</p>
                        <p class="iconSubtitle">{{ userData.typePlan }}</p>
                      </div>
                    </div>
                    <div style="display: flex;height: 31px;width: 100%;">
                      <img :src="clockIconMobile" alt="clockIcon" class="iconMobile">
                      <div style="display: block;">
                        <p class="iconTitle">Activación:</p>
                        <p class="iconSubtitle">En 30 días continuos</p>
                      </div>
                    </div>
                    <div style="display: flex;height: 31px;width: 100%;">
                      <img :src="cashIconMobile" alt="cashIcon" class="iconMobile">
                      <div style="display: block;">
                        <p class="iconTitle">Prima mensual:</p>
                        <p class="iconSubtitle">{{ planData.plan.values[0].priceString }}</p>
                      </div>
                    </div>
                  </div>
                

                  <div v-if="screen < 800" style="width: 100%; display: flex;">
                    <v-btn  style="background-color: #4F74E3 !important; color: white; display: flex; justify-content: center;" @click="validate()" block>
                    Continuar
                  </v-btn>
                  </div>
                  
                </div>  
              
              </div>
            </div>

              <!-- <br><br><br><br> -->

            </v-container>

            
          </v-form>
        </v-stepper-content>

        </v-row>

        <div v-if="screen > 800" style="position: fixed; bottom: 0; left: 0; width: 100%; z-index: 9999;">
          <div class="cta-bar">
            <div class="cta-item">
              <div class="cta-content">
                <img :src=ticketFooter alt="ticketFooter">
                <div style="margin-left: 10px;">
                  <div class="cta-label">Tipo de plan:</div>
                  <div v-if="this.planData.plan.cantBenf.includes('familiar')" class="cta-value">Familiar</div>
                  <div v-else class="cta-value">Individual</div>
                </div>
              </div>
            </div>

            <div class="cta-item">
              <div class="cta-content">
                <img :src=watchFooter alt="watchFooter">
                <div style="margin-left: 10px;">
                  <div class="cta-label">Activación:</div>
                  <div class="cta-value">En 30 días continuos</div>
                </div>
              </div>
            </div>

            <div class="cta-item">
              <div class="cta-content">
                <img :src=currencyFooter alt="currencyFooter">
                <div style="margin-left: 10px;">
                  <div class="cta-label">Prima mensual:</div>
                  <div class="cta-value">{{ formatPrice(planData.plan.values[0].priceCLP) }} (UF {{ (planData.plan.values[0].price).toFixed(2) }})</div>
                </div>
              </div>
            </div>

            <div v-if="loadingNext == false" class="cta-item">
              <v-btn :class="btnContinue" style="background-color: #4F74E3 !important;" @click="validate()" block>
                Continuar
              </v-btn>
            </div>

            <div v-if="loadingNext == true" class="text-center" style="margin-right:17%; margin-left: 5%;">
                <v-progress-circular :size="20" color="white" indeterminate></v-progress-circular>
            </div>
          </div>
        </div>

  
            <!-- <v-btn :class="btnContinue" @click="validate()" style="display: flex; justify-content: center; width: 100%;">
              Continuar
            </v-btn>
           -->
            <!-- <br>
            <br>

            <v-btn text @click="volverAgregar()">
              Atrás
            </v-btn> -->
     
            

      </v-stepper-items>

      
    </v-stepper>

  </v-container>
</template>

<script>

import Titulo from "../components/Titulo.vue";
import NavBar from "@/components/NavBar.vue";

import CryptoJS from 'crypto-js';
import ShieldService from "../services/shield.service";

import doctorImage from "@/assets/images/doctorImage.png";
import doctorImageMobile from "@/assets/images/doctorImageMobile.png";
import clockIconMobile from "@/assets/images/clockIcon.svg";
import shieldIconMobile from "@/assets/images/shieldIcon.svg";
import cashIconMobile from "@/assets/images/cashIcon.svg";
import ticketFooter from "@/assets/images/ticketFooter.svg";
import watchFooter from "@/assets/images/watchFooter.svg";
import currencyFooter from "@/assets/images/currencyFooter.svg";

export default {
  name: "Step4",
  components: { Titulo, NavBar },
  data: () => ({
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    secretKey: process.env.VUE_APP_CRYPT,
    loadMounted: false,
    formatter: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }),
    doctorImage,
    doctorImageMobile,
    clockIconMobile,
    shieldIconMobile,
    cashIconMobile,
    ticketFooter,
    watchFooter,
    currencyFooter,
    loadingNext: false,
    summaryContainerDps: null,
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      typeIsapre: null,
      region: null,
      commune: null,
      comuneCode: null,
      regionCode: null,
      address: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      stepId: null,
      old: null,
      dates: null,
      salud: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
      typePlan: null,
      addressNumber: null,
      addressDepto: null,
      buttonContainer: null,
      btnContinue: null,
      sonExist: false,
      arrayTypesBenef: [],
      oldAux: null,
      day: null,
      month: null,
      year: null,
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'create',
    },
    planData: {
      planOutDesc: null,
      setDesc: false,
      valueDesc: 0,
      couponId: null,
      plan: null,
    },
    benefData: [
      {
        validRut: false,
        tipo: null,
        edad: null,
        name: '',
        surname: '',
        rut: '',
        days: ['Selecciona el mes'],
        months: null,
        years: null,
        date: null,
        newRut: '',
        panel: 0,
        year: null,
        month: null,
        day: null,
        questionOne: null,
        questionTwo: null,
        questionThree: null,
      }
    ],
    labelTitulo: '',
    labelSuperior: '',
    labelTexto: '',
    labelBeneficioss: '',
    textLegal: '',
    vRadioSelect: '',
    textLegalDetalle: '',
    labelRecommend: '',
    valid: false,
    Vstep: '',
    Vflex: '',
    stepperColor: '#4F74E3',
    screen: window.screen.width,
    nameSite: window.location.origin + '/documents/Articule.pdf',
    stepId: null,
    components: { Titulo },
    e1: 6,
    questionRules: [(v) => !!v || "Debe seleccionar una opción"],
  }),
  mounted() {
    // document.body.scrollTop = document.documentElement.scrollTop = 0;
    // document.body.setAttribute('data-sku', 'ONC-003-DPS');

    const userDataAux = sessionStorage.getItem('userData');
    const planDataAux = sessionStorage.getItem('planData');
    const servicesDataAux = sessionStorage.getItem('servicesData');
    const benefDataAux = sessionStorage.getItem('benefData');

    if (userDataAux) {
      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);
    }

    if (servicesDataAux) {
        const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
        const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
        this.servicesData = JSON.parse(decryptedServicesData);
        // console.log("serivcesData: ", this.servicesData);
      }

    if (planDataAux){
      const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
      const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
      this.planData = JSON.parse(decryptedDataPlan);
      // console.log("planData: ", this.planData);
    }

    if(benefDataAux){
      const bytesBenefData = CryptoJS.AES.decrypt(benefDataAux, this.secretKey);
      const decryptedDataBenef = bytesBenefData.toString(CryptoJS.enc.Utf8);
      this.benefData = JSON.parse(decryptedDataBenef);
      // console.log("benefData: ", this.benefData);
    }


    if (this.screen > 1001) {
      this.Vstep = 'VstepDesktop';
      this.vista = 'vista2';
      this.labelTitulo ="labelTitulo";
      this.labelSuperior = 'labelSuperior';
      this.labelTexto = 'labelTexto';
      this.labelBeneficioss = 'labelBeneficioss';
      this.vRadioSelect = 'vRadioSelect';
      this.textLegal= 'textLegal';
      this.textLegalDetalle = 'textLegalDetalle';
      this.labelRecommend = 'labelRecommend';
      this.summaryContainerDps = 'summaryContainerDps';
      this.btnContinue = 'btnContinue';
      this.buttonContainer = 'buttonContainer';
      this.Vflex = 'VflexDesktop';
      this.rowBody = 'rowBody'
      this.nameRadio = 'nameRadio'
    } else if (this.screen <= 767) {
      this.vista = 'vista';
      this.labelTitulo ="labelTituloMobile";
      this.labelSuperior = 'labelSuperiorMobile';
      this.labelTexto = 'labelTextoMobile';
      this.labelBeneficioss = 'labelBeneficiossMobile';
      this.vRadioSelect = 'vRadioSelectMobile';
      this.textLegal= 'textLegalMobile';
      this.textLegalDetalle = 'textLegalDetalleMobile';
      this.labelRecommend = 'labelRecommend2';
      this.summaryContainerDps = 'summaryContainerDps2';
      this.btnContinue = 'btnContinue2';
      this.buttonContainer = 'buttonContainer2';
      this.Vflex = 'VflexMobile';
      this.rowBody = 'rowBody2'
      this.nameRadio = 'nameRadio2'
    } if (this.screen >= 768 && this.screen <= 1000) {
      this.Vstep = 'VstepDesktop';
      this.vista = 'vista2';
      this.labelTitulo ="labelTitulo";
      this.labelSuperior = 'labelSuperior';
      this.labelTexto = 'labelTexto';
      this.labelBeneficioss = 'labelBeneficioss';
      this.vRadioSelect = 'vRadioSelect';
      this.textLegal= 'textLegal';
      this.textLegalDetalle = 'textLegalDetalle';
      this.labelRecommend = 'labelRecommend';
      this.summaryContainerDps = 'summaryContainerDps';
      this.btnContinue = 'btnContinue';
      this.buttonContainer = 'buttonContainer';
      this.Vflex = 'VflexDesktop';
      this.rowBody = 'rowBody2'
      this.nameRadio = 'nameRadio2'
    }

    this.loadMounted = true;
  },
  methods: {
    back() {
      this.e1--;
    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    async validate() {

      if (this.$refs.form2.validate()) {
        this.loadingNext = true
        if(this.benefData.some(benef => benef.questionOne === 'Si' || benef.questionTwo === 'Si')){
          this.$router.push({ path: '/og/dps-fallida' })
        }else if (this.userData.questionOne == 'Si' || this.userData.questionTwo == 'Si') {
          this.$router.push({ path: '/og/dps-fallida' })
        } else {
          const userDataLocal = JSON.stringify(this.userData);
          const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
          sessionStorage.setItem('userData', encryptedUserDataLocal);

          const benefDataLocal = JSON.stringify(this.benefData);
          const encryptedBenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();
          sessionStorage.setItem('benefData', encryptedBenefDataLocal)
          
          let shieldRes;

          if (this.userData.email && this.activeCampaingUse == 'TRUE') {
            const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);
            if (activeCampaingRes.data.data.meta.total == 1) {
              this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;
              await ShieldService.updateContactActiveCampain(this.userData, null, this.servicesData, 'dps');
            } else {
              shieldRes = await ShieldService.createContactActiveCampain(this.userData, this.servicesData);

              if (shieldRes.data.status == 'ok') {
                this.servicesData.contactID = shieldRes.data.data.contacts[0].id;
              }
            }

            const servicesDataLocal = JSON.stringify(this.servicesData);
            const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
            sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

          }

          if (this.planData.plan.cantBenf && this.planData.plan.cantBenf.includes('familiar')) {
            this.$router.push({ path: '/og/beneficiarios' })
          } else {
            this.$router.push({ path: '/og/datos-contratante' });
          }

        }
      }
    },
    capitalizeName(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    volverAgregar() {
      this.$router.push({ path: '/og/planes' });
      // if (this.userData.typePlan == 'Individual') {
      //   this.$router.push({ path: '/og/planes' });
      // } else {
      //   this.$router.push({ path: '/og/beneficiarios' });
      // }
    }
  }
};

</script>

<style lang="scss">

.cta-bar {
  display: flex;
  align-items: center;
  gap: 16px;    
  padding: 12px 16px;
  background: #2a3a86;
  color: #fff;
  border-radius: 6px;
}

.cta-item {
  flex: 1 1 0;
  min-width: 0;        
  display: flex;
  align-items: center;
}

.cta-content {
  display: flex;
  align-items: center;
}

.cta-label {
  font-size: 12px;
  line-height: 1;
  opacity: 0.85;
}

.cta-value {
  font-size: 12px;
}

.VstepDesktop {
  margin-top: -0.3%
}

.VflexDesktop {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 50px;
}

.VflexMobile {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 30px;
    margin-top: -2.3%;
    margin-bottom: 2.3%
}

.buttonContainer2{
  margin-bottom: -14%;
}
.iconTitle{
  color: #FFFFFF;
  font-weight: 700;
  font-size: 12px;
  text-align: left;
  line-height: 15px !important;
  margin-left: 6%;
  margin-bottom: 6% !important;
}
.iconSubtitle{
  color: #FFFFFF;
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  line-height: 15px !important;
  margin-left: 6%;
}
.iconMobile{
  display: flex;
  justify-content: center;
  width: 24px !important;
  margin: auto;
  margin-top: -1%;
}
.btnContinue{
  background-color: #4F74E3 !important; 
  color: white !important; 
  border-radius: 12px; 
  width: 300px;
}
.btnContinue2{
  background-color: #4F74E3 !important; 
  color: white !important; 
  border-radius: 24px; 
  width: 200px;
  margin-top: -2%;
}
.summaryContainerDps2{
  background-color: #2D387C;
  position: absolute;
  bottom: 0;
  z-index: 9999;
  width: 100%;
  margin-left: -47%;
  margin-right: -47%;
  height: auto;
  padding-top: 3%;
  padding-bottom: 3%;
  margin-bottom: 3% !important;
}
.labelRecommend{
  font-size: 15px; 
  opacity: 0.90;
}
.labelRecommend2{
  font-size: 13px; 
  opacity: 0.90;
  font-weight: 400;
  width: 94%;
  margin: auto;
}
.labelNumLlamar {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 50px;
  top: 175px;
  text-align: center;
}

.labelSuperior {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: justify;
  color: #232323;
  opacity: 0.75;
  height: 103px;
}

.labelSuperiorMobile {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 16px;
  text-align: justify;
  color: #232323;
  opacity: 0.75;
  height: 103px;
}

.labelTitulo {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: #2D387C;
  text-align: center;
}

.labelTituloMobile {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: #2D387C;
  text-align: center;
  width: 74%;
  margin: auto;
  justify-content: center !important;
}

.labelQuestion1 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #4040CF;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  justify-content: left;
}

.labelTexto {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 30px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  text-align: justify;
}

.labelTextoMobile {
  display: block; 
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: #333333;
  height: 138px;
  text-align: justify !important;
}

.textLegalDetalle {
  // font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  justify-content: center;
  margin: auto;
  width: 80%;
  text-align: justify;
}

.textLegalDetalleMobile {
  // font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  text-align: justify;
  justify-content: justify;
  margin: auto;
  width: 80%;
}

.labelTexto-negrita {
  font-family: Poppins;
  font-style: italic;
  font-weight: bold;
  font-size: 11px;
  line-height: 16px;
  color: #232323;
  height: 138px;
  text-align: justify;
  hyphens: auto;
}

.vRadioSelect {
  font-size: 22px;
  display: flex; 
}

.vRadioSelectMobile {
  font-size: 22px;
  display: flex; 
  margin: auto; 
  justify-content: center;
}

.labelBeneficioss {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 150px;
  text-align: justify;
}

.labelBeneficiossMobile {
  display: block; 
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: #232323;
  // opacity: 0.75;
  height: 150px;
  text-align: justify !important;
}

.labelExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelSubExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
}

.labelNoExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelnoSubExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
}

.vista {
  max-width: 1000px;
}

.vista2 {
  min-width: 670px;
}

.textLegal {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 14px;
  gap: 10px;
  max-width: 80%;
  height: 88px;
  background: #ECF0FC;
  border-radius: 4px;
}

.textLegalMobile {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 14px;
  gap: 10px;
  width: 100%;
  height: 100%;
  background: #ECF0FC;
  border-radius: 4px;
}

.step-data {
  max-width: 85%;
  align-items: center;
  // display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 150px;
  }
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 700px !important;
}

.form-box {
  box-sizing: border-box;
  max-width: 800px;
  background: #F3F3F3;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  border-radius: 6px;
}

.v-input .v-label {
  font-size: 12px;
  color: #8E8E8E;
}

h1 {
  font-weight: 500;
  text-align: center;
  color: #464e71;
  margin-bottom: 2rem;
}

h2 {
  font-weight: 500;
  color: #464e71;
  margin-bottom: 1rem;
}

p {
  text-align: center;
}

.back-container {
  width: 100%;
  align-items: flex-start;

  .back-button {


    &:hover {
      opacity: 1;
    }
  }
}

.button-container {
  text-align: center;
}

.forecast-selector {
  text-transform: uppercase;
  font-weight: 600;
  color: #464e71;
}

.v-btn__content {
  padding: 0.75rem;
}

.v-messages__message {
  padding-bottom: 10%;
  text-align: center;
  margin: auto;
}

.rowBody {
  display:flex; 
  align-items: flex-start; 
  width:100%; 
}

.rowBody2 {
  display:flex; 
  align-items: flex-start; 
  width:100%; 
  align-items: center; 
  flex-direction: column;
}

.nameRadio {
  display: inline-block; 
  min-width: 200px; 
  margin-right: 10px; 
  font-size: 16px; 
  font-weight: 400; 
  color: #232323; 
  opacity: 0.75;
}

.nameRadio2 {
  display: inline-block; 
  min-width: 100px; 
  margin-right: 10px; 
  font-size: 16px; 
  font-weight: 400; 
  color: #232323; 
  opacity: 0.75;
}

</style>